import Vue from 'vue'
import App from './App.vue'
import * as urls from '@/config/env';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import './assets/css/main.css';

Vue.config.productionTip = false

console.log("urls", urls)
// Object.keys(urls).forEach(key => {
//   Vue.prototype[key] = urls[key];
// });

Vue.use(Vant)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
